module.exports = __webpack_public_path__ + "img/logo.8520bcb1.jpg";